<template>
  <div class="inteBox">
    <intNavheader activeNameCheck="five"></intNavheader>
    <div class="titleTopLine"></div>
    <div class="titleTopCenter noflex-l-s">
      <div class="titleTopCenterLeft">
        <div class="titleTopCenterLeftBox" @click="goPremangeseeDtail">病例详情</div>
      </div>
      <div class="titleTopCenterCenter">
        <div class="titleTopCenterCenterTop">
          <div class="iq-card-body">
            <div class="table-top flex-space-between">
              <el-page-header @back="goBack" :content="type == 1 ? '账单详情' : '退费详情'"> </el-page-header>
              <div class="flex-end">
                <div v-if="type == 1 && detailInfo.state == 0">
                  <el-button type="primary" size="small" @click="toCharge">收费</el-button>
                </div>
                <!-- <div style="margin-left: 10px" v-if="type == 1 && (detailInfo.state == 1 || detailInfo.state == 3 || detailInfo.state == -3 || detailInfo.state == 5)">
                  <el-button type="success" size="small" @click="toPrint($refs.payList)">打印收费凭证</el-button>
                </div> -->
              </div>
            </div>
            <div class="table-line"></div>
            <div class="table-content">
              <div class="top-info flex-space-between">
                <div class="left-i">
                  <div class="flex-start">
                    <img v-if="patientInfo.sex" src="@/assets/img/touxiang03.png" />
                    <img v-else src="@/assets/img/touxiang04.png" />
                    <div class="userName">{{ detailInfo.patientName ? detailInfo.patientName : "无" }}</div>
                  </div>
                  <div class="info-div">
                    <span class="t1"
                      ><span class="t2">性别：</span><span v-if="patientId">{{ patientInfo.sex == true ? "男" : "女" }}</span
                      ><span v-else>无</span></span
                    >
                    <span class="t1"><span class="t2">年龄：</span>{{ patientInfo.age ? patientInfo.age : "无" }}</span>
                    <span><i class="el-icon-phone t2"></i>：{{ patientInfo.phone ? patientInfo.phone : "无" }}</span>
                  </div>
                </div>
                <div class="center-i">
                  <div class="t1">
                    <span class="t2">就诊类型：</span>
                    <template v-if="detailInfo.diagnoseType">复诊</template>
                    <template v-else>初诊</template>
                  </div>
                  <div class="t1">
                    <span class="t2">就诊时间：</span>
                    <span>{{ mZPrescriptionInfo.mzPrescriptionOut.addTime | timefilters }}</span>
                  </div>
                  <div class="t1">
                    <span class="t2">看诊医生：</span>
                    <span>{{ mZPrescriptionInfo.mzPrescriptionOut.userName ? mZPrescriptionInfo.mzPrescriptionOut.userName : "无" }}</span>
                    <span v-if="mZPrescriptionInfo.mzPrescriptionOut.userPhone">【{{ mZPrescriptionInfo.mzPrescriptionOut.userPhone }}】</span>
                  </div>
                </div>
                <div class="right-i">
                  <div class="t1">
                    <span class="t2">审核医生：</span>
                    <span>{{ mZPrintPrescription.doctorName ? mZPrintPrescription.doctorName : "无" }}</span>
                    <span v-if="mZPrintPrescription.doctorPhone">【{{ mZPrintPrescription.doctorPhone }}】</span>
                    <span>{{ mZPrescriptionInfo.mzPrescriptionOut.auditTime | timefilters }}</span>
                  </div>
                  <!-- <div class="t1">
                    <span class="t2">药剂师：</span>
                    <span>{{ mZPrintPrescription.pharmacistName ? mZPrintPrescription.pharmacistName : "无" }}</span>
                    <span v-if="mZPrintPrescription.pharmacistPhone">【{{ mZPrintPrescription.pharmacistPhone }}】</span>
                  </div> -->
                  <div class="t1">
                    <span class="t2">诊断：</span>
                    <span>{{ detailInfo.diagnoseResult ? detailInfo.diagnoseResult : "无" }}</span>
                  </div>
                </div>
                <div class="right-img">
                  <img v-if="detailInfo.state == 1 && detailInfo.refundMoney == 0" src="@/assets/img/image_paid.png" />
                  <img v-if="detailInfo.state == -1" src="@/assets/img/image_refund.png" />
                  <img v-if="detailInfo.state == 1 && detailInfo.refundMoney > 0 && detailInfo.refundMoney < detailInfo.totalPayMoney" src="@/assets/img/image_refundBuFen.png" />
                </div>
              </div>
              <div class="numDiv2 flex-end">
                <div class="flex-start">
                  <div>总金额：¥{{ detailInfo.totalMoney ? detailInfo.totalMoney.toFixed(2) : "0.00" }}</div>
                </div>
              </div>
              <div class="infoDiv flex-space-between">
                <div>
                  <span class="t1">取药方式：</span>
                  <span class="t2" v-if="detailInfo.isSelef">自取 </span>
                  <span class="t2" v-else>快递 收件人信息：{{ detailInfo.takeAddress ? detailInfo.takeAddress : "无" }} </span>
                </div>
              </div>
              <div class="numDiv">
                <div class="flex-start" v-for="(item, i) in detailInfo.payments" :key="i">
                  <!-- type 付款类型 0收费 1退费 2还款 -->
                  <div class="flex-start desc">
                    <div class="t1">
                      <span class="t2">
                        <span v-if="item.type == 0" class="type0">收费：</span>
                        <span v-if="item.type == 1" class="type1">退费：</span>
                        <span v-if="item.type == 2" class="type2">还款：</span> 时间：</span
                      >{{ item.paySuccessTime | timefilters }}
                    </div>
                    <div><span class="t2"> 操作员：</span>{{ item.userName }}</div>
                  </div>
                  <div class="flex-start center-num desc">
                    <div v-if="item.type == 0">
                      <span class="t2">收款金额：</span>
                      <!-- <span>¥{{ (item.totalMoney - item.discountsMoney).toFixed(2) }}</span> -->
                      <span>¥{{ item.totalMoney.toFixed(2) }}</span>
                    </div>
                    <div v-if="item.type == 1">
                      <span class="t2">退款金额：</span>
                      <span>¥{{ item.totalMoney.toFixed(2) }}</span>
                    </div>
                  </div>
                  <div class="flex-end right-num desc">
                    <div class="t1">付款方式：</div>
                    <div class="t3">
                      <span v-if="item.payWay == 0">余额</span>
                      <span v-if="item.payWay == 1">微信</span>
                      <span v-if="item.payWay == 2">支付宝</span>
                      <span v-if="item.payMoney >= 0">¥{{ item.payMoney ? item.payMoney.toFixed(2) : "0.00" }}</span>
                      <span v-if="item.payMoney < 0">¥0.00</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="title" v-if="orderGrouped[2].length > 0">检查治疗项</div>
              <el-table :data="orderGrouped[2]" style="width: 100%" :header-cell-style="{ background: '#F5F7FC' }" v-if="orderGrouped[2].length > 0">
                <el-table-column prop="entityName" label="检查名称" align="center"></el-table-column>
                <el-table-column prop="money" label="单价(元)" align="center">
                  <template slot-scope="scope">
                    {{ scope.row.money.toFixed(2) }}
                  </template>
                </el-table-column>
                <el-table-column prop="amount" label="数量" align="center"></el-table-column>
                <el-table-column prop="countMoney" label="总金额(元)" align="center">
                  <template slot-scope="scope">
                    {{ scope.row.countMoney.toFixed(2) }}
                  </template>
                </el-table-column>
                <el-table-column prop="addTime" label="状态" align="center" width="150px">
                  <template slot-scope="scope">
                    <el-tag type="warning" v-if="scope.row.orderState == 0" size="small">待支付</el-tag>
                    <el-tag type="success" v-if="scope.row.orderState == 1" size="small">已支付</el-tag>
                    <el-tag type="danger" v-if="scope.row.orderState == -1" size="small">已退费</el-tag>
                  </template>
                </el-table-column>
              </el-table>
              <div class="title" v-if="orderGrouped[1].length > 0">处方药</div>
              <el-table :data="orderGrouped[1]" style="width: 100%" :header-cell-style="{ background: '#F5F7FC' }" v-if="orderGrouped[1].length > 0">
                <el-table-column prop="prescriptionType" label="处方类型">
                  <template slot-scope="scope">
                    <p v-if="scope.row.prescriptionType == 0">{{userInfo.doctorHealthManagerType == 1 ? '临方配制' : '方剂处方'}}</p>
                    <p v-if="scope.row.prescriptionType == 1">成药处方</p>
                    <p v-if="scope.row.prescriptionType == 2">输液处方</p>
                    <p v-if="scope.row.prescriptionType == 3">营养处方</p>
                  </template>
                </el-table-column>
                <el-table-column prop="prescriptionName" label="处方名称" align="center"></el-table-column>
                <el-table-column prop="entityName" label="药品名称" align="center">
                  <template slot-scope="scope">
                    <span>{{ scope.row.entityName }} </span><span v-if="scope.row.remark ">/{{ scope.row.remark }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="specification" label="规格" align="center">
                  <template slot-scope="scope">
                    <p>{{ scope.row.specification }}/{{ scope.row.specificationUnit }}</p>
                  </template>
                </el-table-column>
                <el-table-column prop="productFactory" label="厂家" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column prop="money" label="单价(元)" align="center">
                  <template slot-scope="scope"> {{ scope.row.money.toFixed(2) }}/{{ scope.row.isSeparate ? scope.row.separateNumberUnit : scope.row.specificationUnit }}
                </template>
                </el-table-column>
                <el-table-column prop="amount" label="数量" align="center">
                  <template slot-scope="scope"> {{ scope.row.amount }}{{ scope.row.isSeparate ? scope.row.separateNumberUnit : scope.row.specificationUnit }} </template>
                </el-table-column>
                <el-table-column prop="countMoney" label="总金额(元)" align="center">
                  <template slot-scope="scope">
                      {{ scope.row.countMoney.toFixed(2) }}
                  </template>
                </el-table-column>
                <el-table-column prop="dosage" label="剂数" align="center">
                  <template slot-scope="scope">
                    {{ scope.row.dosage ? scope.row.dosage : "" }}
                  </template>
                </el-table-column>
                <el-table-column prop="addTime" label="状态" align="center" width="150px">
                  <template slot-scope="scope">
                    <el-tag type="warning" v-if="scope.row.orderState == 0" size="small">待支付</el-tag>
                    <el-tag type="success" v-if="scope.row.orderState == 1" size="small">已支付</el-tag>
                    <el-tag type="danger" v-if="scope.row.orderState == -1" size="small">已退费</el-tag>
                  </template>
                </el-table-column>
              </el-table>
              <div class="title" v-if="orderGrouped[0].length > 0">直接售药</div>
              <el-table :data="orderGrouped[0]" style="width: 100%" :header-cell-style="{ background: '#F5F7FC' }" v-if="orderGrouped[0].length > 0">
                <el-table-column prop="entityName" label="药品名称" align="center"></el-table-column>
                <el-table-column prop="specification" label="规格" align="center">
                  <template slot-scope="scope">
                    <p v-if="scope.row.specification">{{ scope.row.specification }}/{{ scope.row.specificationUnit }}</p>
                  </template>
                </el-table-column>
                <el-table-column prop="productFactory" label="厂家" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column prop="money" label="单价(元)" align="center">
                  <template slot-scope="scope"> {{ scope.row.money.toFixed(2) }}/{{ scope.row.isSeparate ? scope.row.separateNumberUnit : scope.row.specificationUnit }} </template>
                </el-table-column>
                <el-table-column prop="amount" label="数量" align="center">
                  <template slot-scope="scope"> {{ scope.row.amount }}{{ scope.row.isSeparate ? scope.row.separateNumberUnit : scope.row.specificationUnit }} </template>
                </el-table-column>
                <el-table-column prop="countMoney" label="总金额(元)" align="center">
                  <template slot-scope="scope">
                    {{ scope.row.countMoney.toFixed(2) }}
                  </template>
                </el-table-column>
                <el-table-column prop="addTime" label="状态" align="center" width="150px">
                  <template slot-scope="scope">
                    <el-tag type="warning" v-if="scope.row.orderState == 0" size="small">待支付</el-tag>
                    <el-tag type="success" v-if="scope.row.orderState == 1" size="small">已支付</el-tag>
                    <el-tag type="danger" v-if="scope.row.orderState == -1" size="small">已退费</el-tag>
                  </template>
                </el-table-column>
              </el-table>
              <div class="title" v-if="orderGrouped[99].length > 0">其他收费</div>
              <el-table :data="orderGrouped[99]" style="width: 100%" :header-cell-style="{ background: '#F5F7FC' }" v-if="orderGrouped[99].length > 0">
                <el-table-column prop="entityName" label="费用名称">
                  <template slot-scope="scope"> {{ scope.row.entityName }}<span style="color: red; font-size: 12px; margin-left: 10px" v-if="scope.row.orderType == 5 || scope.row.orderType == 8">(不可退)</span> </template>
                </el-table-column>
                <el-table-column prop="countMoney" label="金额(元)" align="center">
                  <template slot-scope="scope">
                    {{ scope.row.countMoney.toFixed(2) }}
                  </template>
                </el-table-column>
                <el-table-column prop="addTime" label="状态" align="center" width="150px">
                  <template slot-scope="scope">
                    <el-tag type="warning" v-if="scope.row.orderState == 0" size="small">待支付</el-tag>
                    <el-tag type="success" v-if="scope.row.orderState == 1" size="small">已支付</el-tag>
                    <el-tag type="danger" v-if="scope.row.orderState == -1" size="small">已退费</el-tag>
                  </template>
                </el-table-column>
              </el-table>

              <div ref="payList" style="width: 600px; visibility: hidden" :class="isPrint ? 'printBox2' : ''">
                <div class="print-d">
                  <div class="p-t al">收费凭证</div>
                  <div class="oneLine2"></div>
                  <div>病历号：{{ mZPrintPrescription.diagnoseNumber }}</div>
                  <div v-if="detailInfo.payments && detailInfo.payments.length > 0">收费时间：{{ detailInfo.payments[0].paySuccessTime | timefilters }}</div>
                  <div v-if="detailInfo.payments && detailInfo.payments.length > 0">收费员：{{ detailInfo.payments[0].userName }}</div>
                  <div class="twoLine"></div>
                  <div class="flex-space-between">
                    <div class="text-l">姓名：{{ mZPrintPrescription.patientName }}</div>
                    <div class="text-r">年龄：{{ mZPrintPrescription.patientAge }}</div>
                  </div>
                  <div>电话：{{ mZPrintPrescription.patientPhone }}</div>
                  <div>诊断结果：{{ mZPrescriptionInfo.mzPrescriptionOut.diseaseDiagnose }}</div>
                  <div class="oneLine" v-if="orderGrouped[0].length > 0"></div>
                  <!-- 直接售药 -->
                  <el-table class="printTab" :data="orderGrouped[0]" style="width: 100%" :header-cell-style="{ background: '#fff' }" v-if="orderGrouped[0].length > 0">
                    <el-table-column prop="entityName" label="药品名称"></el-table-column>
                    <el-table-column prop="amount" label="数量" align="center">
                      <template slot-scope="scope"> {{ scope.row.amount }}{{ scope.row.isSeparate ? scope.row.separateNumberUnit : scope.row.specificationUnit }} </template>
                    </el-table-column>
                    <el-table-column prop="money" label="单价(元)" align="right">
                      <template slot-scope="scope"> {{ scope.row.money.toFixed(2) }}/{{ scope.row.isSeparate ? scope.row.separateNumberUnit : scope.row.specificationUnit }} </template>
                    </el-table-column>
                  </el-table>
                  <div class="oneLine" v-if="prescriptionGrouped[1].length > 0"></div>
                  <!-- 成药处方 -->
                  <el-table class="printTab" :data="prescriptionGrouped[1]" style="width: 100%" :header-cell-style="{ background: '#fff' }" v-if="prescriptionGrouped[1].length > 0">
                    <el-table-column prop="entityName" label="药品名称"></el-table-column>
                    <el-table-column prop="amount" label="数量" align="center">
                      <template slot-scope="scope"> {{ scope.row.amount }}{{ scope.row.isSeparate ? scope.row.separateNumberUnit : scope.row.specificationUnit }} </template>
                    </el-table-column>
                    <el-table-column prop="money" label="单价(元)" align="right">
                      <template slot-scope="scope"> {{ scope.row.money.toFixed(2) }}/{{ scope.row.isSeparate ? scope.row.separateNumberUnit : scope.row.specificationUnit }} </template>
                    </el-table-column>
                  </el-table>
                  <div class="oneLine" v-if="prescriptionGrouped[2].length > 0"></div>
                  <!-- 输液处方 -->
                  <el-table class="printTab" :data="prescriptionGrouped[2]" style="width: 100%" :header-cell-style="{ background: '#fff' }" v-if="prescriptionGrouped[2].length > 0">
                    <el-table-column prop="entityName" label="药品名称"></el-table-column>
                    <el-table-column prop="amount" label="数量" align="center">
                      <template slot-scope="scope"> {{ scope.row.amount }}{{ scope.row.isSeparate ? scope.row.separateNumberUnit : scope.row.specificationUnit }} </template>
                    </el-table-column>
                    <el-table-column prop="money" label="单价(元)" align="right">
                      <template slot-scope="scope"> {{ scope.row.money.toFixed(2) }}/{{ scope.row.isSeparate ? scope.row.separateNumberUnit : scope.row.specificationUnit }} </template>
                    </el-table-column>
                  </el-table>
                  <div class="oneLine" v-if="mZPrescriptionInfo.mzPrescriptionOut.mzPrescriptionYP.length > 0"></div>
                  <!-- 方剂处方 -->
                  <el-table class="printTab" :data="mZPrescriptionInfo.mzPrescriptionOut.mzPrescriptionYP" style="width: 100%" v-if="mZPrescriptionInfo.mzPrescriptionOut.mzPrescriptionYP.length > 0">
                    <el-table-column prop="prescriptionName" label="饮片名称"></el-table-column>
                    <el-table-column prop="dosage" label="数量" align="center"></el-table-column>
                    <el-table-column prop="prescriptionMoney" label="总金额(元)" align="right"></el-table-column>
                  </el-table>
                  <div class="oneLine" v-if="orderGrouped[99].length > 0"></div>
                  <!-- 代煎费 -->
                  <el-table class="printTab" :data="orderGrouped[99]" style="width: 540px" :header-cell-style="{ background: '#fff' }" v-if="orderGrouped[99].length > 0">
                    <el-table-column prop="entityName" label="名称"></el-table-column>
                    <el-table-column prop="countMoney" label="金额(元)" align="right"></el-table-column>
                  </el-table>
                  <div class="twoLine"></div>
                  <div class="text-r" style="font-size: 20px">实付：{{ detailInfo.totalMoney ? detailInfo.totalMoney.toFixed(2) : "0.00" }}元</div>
                </div>
              </div>
            </div>
            <el-dialog :title="DialogTitle" :visible.sync="setDialog" width="30%">
              <el-form class="dialog-form" :model="charge" ref="chargeForm" :label-width="formLabelWidth" :rules="rules">
                <el-form-item label="应收金额" prop="num" style="color: #ff0000" class="numT">
                  {{ charge.num ? charge.num.toFixed(2) : "0.00" }}
                </el-form-item>
                <el-form-item label="挂账">
                  <el-switch v-model="charge.credit"></el-switch>
                </el-form-item>
                <template v-if="charge.credit">
                  <el-form-item label="姓名" prop="userName">
                    <el-input v-model="charge.userName" style="width: 80%"></el-input>
                  </el-form-item>
                  <el-form-item label="手机号" prop="userPhone" style="width: 80%">
                    <el-input type="number" v-model="charge.userPhone" length="11"></el-input>
                  </el-form-item>
                  <el-form-item label="欠款金额" prop="creditNum">
                    <el-input-number v-model="charge.creditNum" size="small" controls-position="right" :precision="2" :step="0.1" :min="1" class="leftInput"></el-input-number>
                  </el-form-item>
                </template>
                <el-form-item label="付款方式" prop="type">
                  <el-radio-group v-model="charge.type">
                    <el-radio :label="1">现金</el-radio>
                    <el-radio :label="2">微信</el-radio>
                    <el-radio :label="3">支付宝</el-radio>
                    <el-radio :label="4">银行卡</el-radio>
                    <el-radio :label="5">其他</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="付款金额" prop="payNum">
                  <el-input-number v-model="charge.payNum" size="small" controls-position="right" :precision="2" :step="0.1" :min="1" class="leftInput"></el-input-number>
                </el-form-item>
                <el-form-item label="找零">
                  {{ charge.change ? charge.change.toFixed(2) : "0.00" }}
                </el-form-item>
              </el-form>
              <div slot="footer" class="dialog-footer">
                <el-button @click="CloseBtn('chargeForm')">取 消</el-button>
                <el-button type="primary" @click="SaveBtn('bankCardForm')">确 定</el-button>
              </div>
            </el-dialog>
          </div>
        </div>
      </div>
    </div>
    <div class="titleTopLine"></div>
  </div>
</template>
<script>
import intNavheader from "../../components/intNavheader";
import { patientMain } from "../../components/patienTmanagement/patienTmanagement";
import { Outpatient } from "@/components/Drug/Outpatient";
import printJS from "print-js";
import html2Canvas from "html2canvas";
export default {
  components: {
    intNavheader,
  },
  data() {
    var drugPatient = new patientMain(this.TokenClient, this.Services.Authorization);
    var outpatient = new Outpatient(this.TokenClient, this.Services.Drug);
    return {
      drugPatientDomain: drugPatient,
      OutpatientDomain: outpatient,
      userInfo: this.$store.state.localData.userInfo,
      tableData: [],
      detailInfo: {
        gender: 0,
      },
      DialogTitle: "收费",
      setDialog: false,
      formLabelWidth: "100px",
      charge: {
        num: 12,
        type: 1,
        payNum: 12,
        change: 0,
      },
      orderId: this.$route.query.orderId,
      type: this.$route.query.type, //1收费2退费
      form: {
        name: "",
        type: [],
        drug: [
          {
            edit: true,
            name: "",
            guidancePrice: null,
            membershipPrice: null,
            ordinaryPrice: null,
            stockNum: null,
            rank: null,
          },
        ],
      },
      rules: {
        name: [{ required: true, message: "请输入商品名称", trigger: "blur" }],
        coverPicture: [{ required: true, type: "array", message: "请上传商品封面", trigger: "blur" }],
        memberShare: [
          { pattern: /(^[1-9]\d*(\.\d{1,2})?$)|(^0(\.\d{1,2})?$)/, message: "小数点后保留两位", trigger: "blur" },
          { required: true, message: "请输入正确的金额", trigger: "blur" },
        ],
        ordinaryShare: [
          { pattern: /(^[1-9]\d*(\.\d{1,2})?$)|(^0(\.\d{1,2})?$)/, message: "小数点后保留两位", trigger: "blur" },
          { required: true, message: "请输入正确的金额", trigger: "blur" },
        ],
        namegg: [{ required: true, message: "请输入规格名称", trigger: "blur" }],
        guidancePrice: [
          { pattern: /(^[1-9]\d*(\.\d{1,2})?$)|(^0(\.\d{1,2})?$)/, message: "小数点后保留两位", trigger: "blur" },
          { required: true, message: "请输入商品指导价", trigger: "blur" },
        ],
        doctorPrice: [
          { pattern: /(^[1-9]\d*(\.\d{1,2})?$)|(^0(\.\d{1,2})?$)/, message: "小数点后保留两位", trigger: "blur" },
          { required: true, message: "请输入商品价格", trigger: "blur" },
        ],
        membershipPrice: [
          { pattern: /(^[1-9]\d*(\.\d{1,2})?$)|(^0(\.\d{1,2})?$)/, message: "小数点后保留两位", trigger: "blur" },
          { required: true, message: "请输入商品会员价", trigger: "blur" },
        ],
        ordinaryPrice: [
          { pattern: /(^[1-9]\d*(\.\d{1,2})?$)|(^0(\.\d{1,2})?$)/, message: "小数点后保留两位", trigger: "blur" },
          { required: true, message: "请输入商品非会员价", trigger: "blur" },
        ],
        categoryId: [{ required: true, message: "请选择商品分类", trigger: "change" }],
        stockNum: [
          { pattern: /^[1-9]\d*$/, message: "请输入大于0，小于10000的正整数", trigger: "blur" },
          { required: true, message: "请输入库存量", trigger: "blur" },
        ],
        rank: [
          { pattern: /^[0-9]\d*$/, message: "请输入整数", trigger: "blur" },
          { required: true, message: "请输入库存量", trigger: "blur" },
        ],
        cancellationOrder: [
          { pattern: /^[1-9]\d*$/, message: "请输入大于0，小于10000的正整数", trigger: "blur" },
          { required: true, message: "请输入正确的分钟数", trigger: "blur" },
        ],
        completionOrder: [
          { pattern: /^[1-9]\d*$/, message: "请输入大于0，小于10000的正整数", trigger: "blur" },
          { required: true, message: "请输入正确的天数", trigger: "blur" },
        ],
        originId: [{ type: "array", required: true, message: "请选择产地", trigger: "change" }],
        introduce: [{ required: true, message: "请输入商品介绍", trigger: "change" }],
        // instructions: [
        //     { required: true, message: '请输入购买须知', trigger: 'change' },
        // ],
      },
      orderGrouped: { 0: [], 1: [], 2: [], 3: [], 4: [], 5: [], 6: [], 7: [], 99: [] },
      patientId: 0,
      patientInfo: {},
      moment: require("moment"),
      patientDiagnoseInfo: {},
      mZPrescriptionInfo: {
        mzCheckItems: [],
        mzOtherCharges: [],
        mzPrescriptionOut: {
          mzPrescriptionSYGroup: [],
          mzPrescriptionCY: [],
          mzPrescriptionYP: [],
        },
      },
      mZPrintPrescription: {},
      isPrint: false,
      //moment: require('moment'),
      prescriptionGrouped: { 0: [], 1: [], 2: [] },
    };
  },
  mounted() {
    if (this.type == 1) {
      this.paymentedDetail();
    } else {
      this.drugRefundDetail();
    }
  },
  methods: {
    goPremangeseeDtail() {
      this.$router.push({
        path: "./PremangeseeDtail",
        query: {
          id: this.detailInfo.patientDiagnoseId,
          isFalse1: false,
        },
      });
    },
    toPrint(div) {
      this.isPrint = true;
      console.log("*****");
      this.$nextTick(() => {
        html2Canvas(div, {
          allowTaint: true,
          taintTest: false,
          useCORS: true,
          dpi: window.devicePixelRatio * 4,
          scale: 4,
        }).then((canvas) => {
          const url = canvas.toDataURL();
          printJS({
            printable: url, // 要打印的id
            type: "image",
            style: "@media print{ @page { size: A4; margin: 0mm -1.5mm; mso-header: none; mso-footer: none;  } body{margin:0 5px}}", //去除页眉页脚
          });
          this.isPrint = false;
        });
      });
    },
    /**
     * 已收费详情
     */
    paymentedDetail() {
      var _this = this;
      _this.OutpatientDomain.PaymentedDetail(
        this.orderId,
        function (data) {
          _this.detailInfo = data.data;
          _this.patientId = _this.detailInfo.patientId;
          _this.patientDiagnoseId = _this.detailInfo.patientDiagnoseId;
          if (_this.patientId) {
            _this.getDetail();
            _this.getPatientDiagnose();
            _this.getMZPrescriptionDetail();
          }
          //orderType 0直接售药 1处方 2检查治疗项 3附加收费 4代煎费用 5审方费用 6快递费 7包装费
          _this.orderGrouped = { 0: [], 1: [], 2: [], 3: [], 4: [], 5: [], 6: [], 7: [], 99: [] }
          if (_this.detailInfo.details.length > 0) {
            _this.detailInfo.details.map(({ orderType, ...rest }) => {
              _this.orderGrouped[orderType] = _this.orderGrouped[orderType] || [];
              rest.orderType = orderType;
              if ((orderType == 0 || orderType == 1) && _this.detailInfo.mzDrugOrgs) {
                let drugOrg = _this.detailInfo.mzDrugOrgs.filter((i) => i.id == rest.entityId);
                if (drugOrg[0]) {
                  rest.specification = drugOrg[0].specification;
                  rest.specificationUnit = drugOrg[0].specificationUnit;
                  rest.productFactory = drugOrg[0].productFactory;
                  rest.isSeparate = drugOrg[0].isSeparate;
                  rest.separateNumber = drugOrg[0].separateNumber;
                  rest.separateNumberUnit = drugOrg[0].separateNumberUnit;
                  rest.remark = drugOrg[0].remark;
                }
              }
              _this.orderGrouped[orderType].push(rest);
              if (orderType == 3 || orderType == 4 || orderType == 5 || orderType == 6 || orderType == 7 || orderType == 8) {
                _this.orderGrouped[99].push(rest)
              }
            });
          }
          _this.prescriptionGrouped = { 0: [], 1: [], 2: [], 3: [] };
          //prescriptionType 0方剂处方 1成药处方 2输液处方
          if (_this.orderGrouped[1].length > 0) {
            _this.orderGrouped[1].map(({ prescriptionType, ...rest }) => {
              _this.prescriptionGrouped[prescriptionType] = _this.prescriptionGrouped[prescriptionType] || [];
              rest.prescriptionType = prescriptionType;
              _this.prescriptionGrouped[prescriptionType].push(rest);
            });
          }
        },
        function (err) {
          console.log(err);
        }
      );
    },
    /**
     * 已退费详情
     */
    drugRefundDetail() {
      var _this = this;
      _this.OutpatientDomain.DrugRefundDetail(
        this.orderId,
        function (data) {
          _this.detailInfo = data.data;
          _this.patientId = _this.detailInfo.patientId;
          _this.patientDiagnoseId = _this.detailInfo.patientDiagnoseId;
          if (_this.patientId) {
            _this.getDetail();
            _this.getPatientDiagnose();
            _this.getMZPrescriptionDetail();
          }
          //orderType 0直接售药 1处方 2检查治疗项 3附加收费 4代煎费用 5审方费用 6快递费 7包装费
          _this.orderGrouped = { 0: [], 1: [], 2: [], 3: [], 4: [], 5: [], 6: [], 7: [], 99: [] }
          if (_this.detailInfo.details.length > 0) {
            _this.detailInfo.details.map(({ orderType, ...rest }) => {
              _this.orderGrouped[orderType] = _this.orderGrouped[orderType] || [];
              rest.orderType = orderType;
              if ((orderType == 0 || orderType == 1) && _this.detailInfo.mzDrugOrgs) {
                let drugOrg = _this.detailInfo.mzDrugOrgs.filter((i) => i.id == rest.entityId);
                rest.specification = drugOrg[0].specification;
                rest.specificationUnit = drugOrg[0].specificationUnit;
                rest.productFactory = drugOrg[0].productFactory;
                rest.isSeparate = drugOrg[0].isSeparate;
                rest.separateNumber = drugOrg[0].separateNumber;
                rest.separateNumberUnit = drugOrg[0].separateNumberUnit;
              }
              _this.orderGrouped[orderType].push(rest);
              if (orderType == 3 || orderType == 4 || orderType == 5 || orderType == 6 || orderType == 7) {
                _this.orderGrouped[99].push(rest)
              }
            });
          }
        },
        function (err) {
          console.log(err);
        }
      );
    },
    getDetail() {
      var _this = this;
      _this.drugPatientDomain.GetPatient(
        _this.patientId,
        function (data) {
          _this.patientInfo = data.data;
        },
        function (err) {}
      );
    },

    getPatientDiagnose() {
      var _this = this;
      _this.drugPatientDomain.GetPatientDiagnoseDetail(
        _this.patientDiagnoseId,
        function (data) {
          _this.patientDiagnoseInfo = data.data;
        },
        function (err) {}
      );
    },
    getMZPrescriptionDetail() {
      var _this = this;
      _this.OutpatientDomain.MZPrescriptionDetail(
        _this.patientDiagnoseId + '/true',
        function (data) {
          _this.mZPrescriptionInfo = data.data;
          _this.getPrintPrescription();
        },
        function (err) {}
      );
    },
    getPrintPrescription() {
      var _this = this;
      _this.drugPatientDomain.MZPrintPrescription(
        _this.patientDiagnoseId,
        this.mZPrescriptionInfo.mzPrescriptionOut.waitAuditUserId ? this.mZPrescriptionInfo.mzPrescriptionOut.waitAuditUserId : this.mZPrescriptionInfo.mzPrescriptionOut.userId,
        _this.mZPrescriptionInfo.mzPrescriptionOut.waitAuditPharmacistId ? _this.mZPrescriptionInfo.mzPrescriptionOut.waitAuditPharmacistId : 0,
        function (data) {
          _this.mZPrintPrescription = data.data;
        },
        function (err) {}
      );
    },
    toRefund() {
      this.$router.push({
        path: "./ChargedOrRefund",
        query: {
          type: 2,
          orderId: this.orderId,
        },
      });
    },
    toCharge() {
      this.$router.push({
        path: "./ChargedOrRefund",
        query: {
          type: 1,
          orderId: this.orderId,
        },
      });
    },
    CloseBtn(formName) {
      this.setDialog = false;
      this.$refs[formName].resetFields();
    },
    saveData() {},
    handleReset() {
      let row = {
        edit: true,
        name: "",
        guidancePrice: null,
        membershipPrice: null,
        ordinaryPrice: null,
        stockNum: null,
        rank: null,
      };
      this.form.drug = [];
      this.form.drug.push(row);
    },
    handleAdd() {
      let row = {
        edit: true,
        name: "",
        guidancePrice: null,
        membershipPrice: null,
        ordinaryPrice: null,
        stockNum: null,
        rank: null,
      };
      this.form.drug.push(row);
    },
    handleDelete(row, index) {
      if (this.form.drug.length == 1) {
        this.$message({
          message: "请至少保留一行",
          type: "warning",
        });
        return;
      }
      this.$message({
        message: "删除成功",
        type: "success",
      });
      this.form.drug.splice(index, 1);
    },
    goBack() {
      this.$router.go(-1);
    },
    addPatient() {
      this.$router.push({
        path: "./AddPatient",
        query: {},
      });
    },
  },
};
</script>
<style scoped lang="scss">
.pageBox {
  text-align: center;
  margin-top: 10px;
}

.inteBox {
  margin: 0;
  padding: 0;
  background-color: #f0f2f5;
}

.titleTop {
  padding: 0px 20px;
  background-color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.titleTopLeft {
  width: 85%;
  display: flex;
  align-items: center;
}

.titleTopLeftImg {
  width: 123px;
  height: 24px;
}

.titleTopLeftImg img {
  width: 100%;
  height: 100%;
}

.tabBox {
  padding-left: 12%;
  margin-top: 10px;
}

.el-tabs__item {
  height: 60px;
  color: white !important;
  text-align: center;
  padding-top: 10px;
  font-size: 25px !important;
  background-color: #00afb5 !important;
  border: none !important;
}

.is-active {
  color: white !important;
  background-color: #00afb5 !important;
}

::v-deep .el-tabs__nav-wrap::after {
  background-color: #ffffff !important;
}

.titleTopRight {
  width: 10%;
  display: flex;
  align-items: center;
  justify-content: space-around;
}

.titleTopRight div {
  margin-left: 10px;
}

.titleTopLine {
  width: 100%;
  height: 12px;
}

.titleTopCenter {
  width: 100%;
  /* height: 100; */
  display: flex;
}

.titleTopCenterLeft {
  width: 15%;
  background-color: #ffffff;
  /* padding-top: 30px; */
  // max-height: 750px;
  overflow: auto;
}

.noflex-l-s {
  display: flex;
  justify-content: space-around;
}

.titleTopCenterLeftBox {
  font-size: 18px;
  color: #06add7;
  border: 1px solid #06afd3;
  border-radius: 6px;
  width: 150px;
  height: 40px;
  text-align: center;
  line-height: 40px;
  margin: 30px auto;
  cursor: pointer;
  /* margin-top: 0; */
}

.titleTopCenterCenter {
  width: 80%;
  border-radius: 6px;
  height: calc(100vh - 64px - 24px);
  overflow: auto;
}

.titleTopCenterCenterTop {
  background-color: #ffffff;
  // padding: 0 40px;
  /* padding-top: 10px;
  padding-bottom: 10px; */
  height: 100%;
  overflow-y: auto;
}

.flex-l {
  display: flex;
  align-items: center;
}

.flex-l-s {
  display: flex;
  align-items: center;
  justify-content: space-around;
}

.noflex-l-s {
  display: flex;
  justify-content: space-around;
}

.flex-l-b {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.Content1Title {
  padding: 20px 0;
  padding-left: 0;
  font-size: 18px;
  height: calc(100% - 20px);
  /* font-weight: bold; */

  color: #333333;
  padding-bottom: 0;
  text-align: left;
}

.titleTopLeftTableC {
  color: #06add7;
  cursor: pointer;
}

.ageInput {
  width: 80%;
}

.typeChecked {
  font-size: 14px;
  color: #ffffff;
  padding: 0px 15px;
  text-align: center;
  background: #00afb5;
  border-radius: 6px;
  cursor: pointer;
}

.notypeChecked {
  background: #f3f9f9;
  border: 1px solid #b9dcdd;
  padding: 0px 15px;
  border-radius: 6px;
  color: #00afb5;
  font-size: 14px;
  text-align: center;
  cursor: pointer;
}

.table3Box {
  border: 1px solid #b9dcdd;
  border-radius: 6px;
  padding: 30px;
  margin-top: 10px;
}

.titleTopright1Line {
  border-bottom: 1px dashed #999999;
}

.titleTopright1 {
  font-size: 16px;
  color: #06add7;
}

.stepInput {
  width: 60%;
  margin-right: 10px;
}

.titleTopCenterLeftBox {
  font-size: 18px;
  color: #06add7;
  border: 1px solid #06afd3;
  border-radius: 6px;
  width: 150px;
  height: 40px;
  text-align: center;
  line-height: 40px;
  margin: 30px auto;
  cursor: pointer;
  /* margin-top: 0; */
}

.titleTopCenterLeftBoxno {
  font-size: 18px;
  color: #cccccc;
  border: 1px solid #cccccc;
  border-radius: 6px;
  width: 150px;
  height: 40px;
  text-align: center;
  line-height: 40px;
  margin: 30px auto;
  cursor: pointer;
  /* margin-top: 0; */
}

.el-page-header {
  line-height: 73px;
  /* padding-left: 20px; */
}

.iq-card-body {
  padding: 0 0 15px;
  height: auto;
}

.table-top {
  width: 96%;
  margin: 0 auto;
}

.table-line {
  width: 100%;
  height: 6px;
  background: #f5f6f7;
  margin: 0 0 15px;
}

.table-content {
  padding: 0 40px;

  .top-info {
    .t1 {
      margin-right: 30px;
    }

    .t2 {
      color: #999999;
    }

    .center-i {
      // margin: 0 40px;
    }

    .right-img {
      margin-right: 10%;
    }

    .userName {
      margin-left: 10px;
    }

    .info-div {
      margin-top: 10px;
    }
  }

  .title {
    height: 60px;
    line-height: 60px;
    font-weight: bold;
  }

  ::v-deep .el-table__row > td {
    /* 去除表格线 */
    border: none !important;
  }

  ::v-deep .el-table th.is-leaf {
    /* 去除上边框 */
    border: none !important;
  }

  ::v-deep .el-table::before {
    /* 去除下边框 */
    height: 0 !important;
  }

  ::v-deep .el-table .el-table__body-wrapper .el-table__cell {
    padding: 10px 0 !important;
  }

  .my-table {
    border: 1px solid #ebeef5;
    padding: 10px 5px;
  }

  .el-form-item .el-form-item {
    margin-bottom: 20px;
  }

  .leftInput {
    width: 100%;
    position: relative;
  }

  .rightTip {
    position: absolute;

    top: 0;
    z-index: 2;
    color: #999999;
  }

  ::v-deep .el-input-number .el-input__inner {
    text-align: left;
  }

  .numDiv {
    padding: 15px;
    background: #fafafa;
    border: 1px solid #e6e6e6;
    border-radius: 8px;
    margin: 20px 0;

    .right-num {
      // margin-right: 10%;
    }

    .center-num {
      // margin: 0 20px;
    }

    .desc {
      margin-right: 2%;
      width: 32%;
    }

    .desc:nth-child(3n) {
      margin-right: 0;
    }

    .type0 {
      color: #67c23a !important;
    }

    .type1 {
      color: #f56c6c !important;
    }

    .type2 {
      color: #e6a23c !important;
    }

    .t1 {
      margin-right: 20px;
    }

    .t2 {
      color: #999999;
    }

    .t3 {
      color: #fe0000;
    }

    .num1 {
      margin: 0 10px;
    }

    ::v-deep .num2 .el-input__inner {
      color: #ff0000;
    }

    .inputNum {
      color: #ff0000;
    }
  }

  .numDiv2 {
    padding: 15px;
    background: #fff7f7;
    border: 1px solid #f4d3d3;
    border-radius: 8px;
    margin: 20px 0;

    .num1 {
      margin: 0 10px;
    }

    .num2 {
      color: #ff0000;
    }

    ::v-deep .num2 .el-input__inner {
      color: #ff0000;
    }

    .inputNum {
      color: #ff0000;
    }
  }

  .infoDiv {
    // margin: 0 20px;

    .t1 {
      margin-right: 20px;
    }

    .t2 {
      color: #5c83f2;
    }
  }
}

.PrintBox {
  width: 600px;
  background: #ffffff;
  font-size: 14px;
  padding: 20px;
  page-break-after: always !important;
  color: #333333;
}

.PrintBoxTitle {
  text-align: center;
  font-size: 22px;
  font-weight: bold;
}

.PrintBoxTitle1 {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.PrintBoxTitle2 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.PrintBoxTitleLine {
  width: 100%;
  height: 1px;
  background: #666666;
  margin: 5px 0;
  // margin-top: -2px;
  margin-right: 10px;
}

.PrintBoxTitleLineD {
  margin: 15px 0;
  border-bottom: 1px dashed #999999;
}

.printBox {
  visibility: visible !important;
  background-color: #adadad;
  color: #333333;
}

.printBox2 {
  visibility: visible !important;
  color: #333333;
}

.printBox3 {
  visibility: visible !important;
  color: #333333;
}

.print-d {
  ::v-deep .printTab .el-table__body-wrapper .el-table__cell {
    padding: 2px 0 !important;
  }
}

.print-d {
  width: 90%;
  margin: 0 auto;
  background: #ffffff;
  font-size: 14px;

  .p-t {
    font-size: 20px;
    font-weight: bold;
    text-align: center;
    padding-top: 20px;
    color: #333333;
  }

  .oneLine {
    margin: 10px 0 0 0;
    border-bottom: 1px dashed #999999;
  }

  .oneLine2 {
    margin: 10px 0;
    border-bottom: 1px solid #999999;
  }

  .twoLine {
    margin: 10px 0;
    height: 3px;
    border-top: 1px dashed #999999;
    border-bottom: 1px dashed #999999;
  }
}

.text-r {
  text-align: right;
}
</style>
